export const LEGAL_NOTICE_EMAIL = 'legal@openx.com';
export const LEGAL_NOTICE_DRAWER_ID = 'deal-troubleshooting-legal-notice-drawer';
export const LEGAL_NOTICE_TITLE_ID = 'deal-troubleshooting-legal-notice-title';
